<template>
  <div class="d-emails">
    <h3 class="h3 mt0">Email Logs</h3>
    <module-spinner
      :active="loading"
      :floating="true"
    />

    <transition
      name="fade"
      mode="out-in"
    >
      <div
        v-if="emailLogsLength > 0"

        key="emails-table"
      >
        <module-table
          :columns="columns"
          :rows="emailLogs.results"
          :row-click="true"

          @row-click="onRowClick"
        />

        <div class="d-emails__more">
          <p class="p">Showing <strong>{{ emailLogsLength }}</strong> of <strong>{{ emailLogsTotal }}</strong> Results</p>
          <module-button
            v-if="emailLogs.next"

            @click.native="getNextPage"

            button="primary"
            label="Load more"
            :loading="loading"
          />
        </div>
      </div>
      <p v-else-if="emailLogsLength === 0 && !loading" class="fw-bold mt2">No Email Logs</p>
    </transition>
  </div>
</template>

<script>
// Vuex
import { mapActions, mapGetters } from 'vuex';

// Services
import { toDateString } from 'services/dateTime';

// Modules
import ModuleDetailList from 'modules/DetailList';
import ModuleButton from 'modules/Button';
import ModuleSpinner from 'modules/Spinner';
import ModuleTable from 'modules/Table';

// Export
export default {
  name: `ui-dashboard-email-logs`,

  // Components
  components: {
    ModuleDetailList,
    ModuleButton,
    ModuleSpinner,
    ModuleTable,
  },

  // Data
  data() {
    return {
      loading: true,
    };
  },

  // Computed
  computed: {
    ...mapGetters(`emails`, [
      `emailLogs`,
      `emailLogsLength`,
      `emailLogsTotal`,
    ]),
    columns() {
      return [
        {
          heading: `Email Address`,
          value: request => request.to,
        },
        {
          heading: `Full Name`,
          value: request => `${request.recipient.first_name} ${request.recipient.last_name}`,
        },
        {
          heading: `Subject`,
          value: request => request.subject,
        },
        {
          heading: `Activities`,
          value: request => request.num_activities || 0,
        },
        {
          heading: `Views`,
          value: request => request.num_views || 0,
        },
        {
          heading: `Clicks`,
          value: request => request.num_clicks || 0,
        },
        {
          header: `Sent`,
          value: request => toDateString(request.created_at),
        },
        {
          heading: `Link`,
          hidden: true,
          align: `right`,
          value: () => ({
            is: ModuleButton,
            bind: {
              label: `View Activity`,
              button: `primary`,
              size: `s`,
              icon: `arrow-right`,
            },
          }),
        },
      ];
    },
  },

  // Methods
  methods: {
    ...mapActions(`emails`, [
      `getEmailLogs`,
    ]),
    getNextPage() {
      if (this.loading) return false;

      this.loading = true;

      setTimeout(() => {
        this.getEmailLogs(this.emailLogs.next)
          .then(() => this.loading = false);
      }, 300);
    },
    onRowClick(id) {
      this.$router.push({
        name: `admin-email-activity`,
        params: {
          id,
        },
      });
    },
  },

  // Lifecycle
  created() {
    this.getEmailLogs()
      .then(() => this.loading = false);
  },
};
</script>



// WEBPACK FOOTER //
// EmailLogs.vue?0551c4e7